<template>
<div class="load-screen">
  <div class="message">
    {{message}}
  </div>
</div>
</template>

<script>
export default {
  name: 'LoadScreen',
  props: ['message']
}
</script>

<style scoped lang="scss">
.load-screen {
    display: flex;
    align-items: center;
    justify-content: center;

    height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/LoadScreen.vue